<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">互联网舆情管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          互联网舆情管理系统面向党政宣传与网信部门，构建覆盖新闻网站、论坛社区、微博微信、短视频平台与移动客户端的全网信息监测体系，实现舆情信息的自动采集、智能研判、分级预警与协同处置，支撑舆情工作由“被动应对”向“主动引导”转变。
        </p>
        <p class="content-paragraph">
          系统以“发现—研判—处置—反馈”闭环为主线：通过关键词与专题模型实现全网实时监测，运用自然语言处理开展情感倾向判断、热点聚类、传播路径溯源与影响力评估，自动生成舆情简报；发现敏感舆情后按等级触发短信、微信等多渠道预警，并通过工单派发实现跨部门协同处置与复盘归档，切实提升网络舆情治理能力。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">全网监测</h3>
            <ul class="capability-list"><li>新闻网站监测</li><li>论坛社区采集</li><li>微博微信监测</li><li>短视频监测</li><li>客户端采集</li><li>关键词配置</li><li>专题监测</li><li>境外舆情</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">智能研判</h3>
            <ul class="capability-list"><li>情感倾向分析</li><li>热点自动聚类</li><li>传播路径溯源</li><li>影响力评估</li><li>敏感信息识别</li><li>自动生成简报</li><li>趋势预测</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">预警处置</h3>
            <ul class="capability-list"><li>分级预警</li><li>短信微信推送</li><li>工单派发</li><li>处置跟踪</li><li>协同会商</li><li>复盘报告</li><li>统计考核</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/yq-monitor.svg"
              alt="海南华德科技有限公司 互联网舆情管理系统 - 全网监测 · 实时信息流与专题跟踪"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>全网监测 · 实时信息流与专题跟踪
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/yq-analysis.svg"
              alt="海南华德科技有限公司 互联网舆情管理系统 - 智能研判 · 热点聚类与传播溯源"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>智能研判 · 热点聚类与传播溯源
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/yq-alert.svg"
              alt="海南华德科技有限公司 互联网舆情管理系统 - 预警处置 · 分级预警与工单协同"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>预警处置 · 分级预警与工单协同
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/yq-brief.svg"
              alt="海南华德科技有限公司 互联网舆情管理系统 - 简报中心 · 自动生成与趋势分析"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>简报中心 · 自动生成与趋势分析
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs11.vue